export enum CursorPositionFormat {
  positionDDMM = "DD°MM.MMMM'",
  positionDMS = 'DD°MM\'SS"',
  positionDegrees = 'DD.dddddd°',
}
